import React from "react";
import { injectIntl } from "react-intl";
var Shortcut = function(param) {
    var description = param.description, keys = param.keys, intl = param.intl;
    var label = intl.formatMessage({
        id: "accessibility.shortcut_description",
        defaultMessage: "{description}, Key {keys}"
    }, {
        description: description,
        keys: keys
    });
    return /*#__PURE__*/ React.createElement("tr", {
        id: "shortcut-".concat(keys.replace("?", "questionmark"))
    }, /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, label), /*#__PURE__*/ React.createElement("span", {
        "aria-hidden": true
    }, description), /*#__PURE__*/ React.createElement("kbd", {
        "aria-hidden": true
    }, keys)));
};
export default injectIntl(Shortcut);
